import { render, staticRenderFns } from "./Page_Renovations.vue?vue&type=template&id=ab8d3e40&scoped=true&"
import script from "./Page_Renovations.vue?vue&type=script&lang=js&"
export * from "./Page_Renovations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8d3e40",
  null
  
)

export default component.exports